import React from "react";

import { RouteComponentProps } from "@reach/router";

import { NavigationConstants } from "@assets/constants";
import { SpinnerPage } from "@components/index";

interface RouteProps extends RouteComponentProps {
  component: typeof React.Component | React.FunctionComponent;
  isLoaded: boolean;
  children?: React.ReactNode;
  mode?: NavigationConstants.PAGE_MODE;
  isKioskMode?: boolean;
}

const Route: React.FC<RouteProps> = ({
  isLoaded,
  component: Component,
  children,
  ...rest
}) => {
  return isLoaded ? (
    <Component {...rest}>{children}</Component>
  ) : (
    <SpinnerPage />
  );
};

export default Route;
